import { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import AdminPage from '../../components/admin/AdminPage';
import { useNavigate, useParams } from 'react-router-dom';
import { WorkPhase, WorkPhaseForm } from './models/investors';
import { PROJECT_WORK_PHASE_ORDER } from './constants/projectConstants';
import useProjectWorkPhases from './hooks/useProjectWorkPhases';
import WorkPhasesTable from './components/WorkPhasesTable';
import WorkPhaseCreateForm from './components/WorkPhaseCreateForm';

const InvestorProjectWorkProgress = () => {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const { doGetWorkPhases, doCreateWorkPhase, doUpdateWorkPhaseProgress, apiErrors } = useProjectWorkPhases();

  const [phases, setPhases] = useState<WorkPhase[]>([]);
  const [loaded, setLoaded] = useState(false);

  const loadPhases = () => {
    setLoaded(false);
    doGetWorkPhases(id)
      .then(setPhases)
      .finally(() => setLoaded(true));
  };

  useEffect(() => {
    loadPhases();
  }, [id]);

  const registeredPhases = new Set(phases.map((p) => p.phase));
  const nextPhase = PROJECT_WORK_PHASE_ORDER.find((p) => !registeredPhases.has(p));

  const handleCreatePhase = async (form: WorkPhaseForm) => {
    const result = await doCreateWorkPhase(id, form);
    if (result === 201) navigate(0);
  };

  const handleUpdateProgress = async (phaseId: string, progress: number) => {
    const result = await doUpdateWorkPhaseProgress(id, phaseId, progress);
    if (result === 200) navigate(0);
  };

  return (
    <AdminPage name="Detalle Avance de Obra" parentName="Proyectos">
      <Row>
        <Col md="6">
          <h5>Fases registradas</h5>
          <WorkPhasesTable
            phases={phases}
            loaded={loaded}
            apiErrors={apiErrors}
            projectId={id}
            onUpdateProgress={handleUpdateProgress}
          />
        </Col>
        {nextPhase && (
          <Col md="6">
            <h5>Registrar siguiente fase</h5>
            <WorkPhaseCreateForm
              nextPhase={nextPhase}
              handleForm={handleCreatePhase}
            />
          </Col>
        )}
      </Row>
    </AdminPage>
  );
};

export default InvestorProjectWorkProgress;
